var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import Button from "@mui/material/Button";
import SaveIcon from "@material-ui/icons/Save";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import {MuiThemeProvider } from '@material-ui/core/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import { muiThemeDesign } from '../../mui-theme-design';
import { makeStyles } from "@mui/styles";
import { Importer, ImporterField } from '../../csv_import/Importer';
//import { Importer, ImporterField } from "react-csv-importer";
import { useDrag } from '@use-gesture/react'



const pageStyles = makeStyles({

    root: {
        display: "flex",
 //       flexFlow: "column wrap",
        gap: "5px",
  //      height: "400px", 
        overflow: "auto",
        "& .MuiList-root": {      
            display: "block",
          //  flexFlow: "row",
            flexWrap: "nowrap",
            gap: "5px",
            height: "400px", // set the height limit to your liking
            overflow: "auto",
            width: "400px",
          
        },
        "& .MuiListItem-root": {
            width: 220,
            height: 12,
         //   color: "#772c97"
        },
        "& .MuiListItemText-root": {
        //    width: 180,
        //    height: 20,
            display: "flex",
            textAlign: "left",
            paddingLeft: "5px",
            alignItems: "center"
        },
        "& .MuiDialog-root": {           
            height: 500,
            fullwidth: true,
            maxWidth: 'lg'
        },
        "& .MuiDialogTitle - root": {
            textAlign: 'center',
            fontWeight: 500,
            fontSize: 'h4.fontSize',
            backgroundColor: "#1976d2",
            color: "#ffffff"
        },
        "& .MuiDialogContent-root": {
           height: 400
        },
        "& .MuiPaper-root": {
            height: 600
        }

    }

});

export default function Roster_Import() {
    const [refresh, setRefresh] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [AllDoneAlert, setAllDoneAlert] = React.useState(false);
    const [successful, setSuccessful] = React.useState([])
    const [duplicates, setDuplicates] = React.useState([])
    var importRows = [];
   // var newRows = [];
    var rowCount;
   //var i;
    const classes = pageStyles();
    const processRows = (rows) => {
     //   console.log(`processRows`, rows)
        let processFields = Object.keys(rows[0]);
    //   console.log(`Fields`, processFields)
        for (var i = 0; i < rows.length; i++) {
      //      console.log(`loop`, rows[i])
            importRows.push(rows[i])
                }
        newRows = [];
    }
    const pushRows = async () => {
        await fetch(`/api/importRoster`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                Users: importRows,
                dependencies: {
                    Password: '123456789'
                   // CostCenterID: 1
                }
            })
        })

            .then(res => res.json())
            .then(json => {
                setSuccessful (json.successfulEntries)
                setDuplicates (json.duplicateEntries)
                setAllDoneAlert(true)
                console.log (AllDoneAlert)
            }
            )

         
            
    };

 /* 
 FRONT-END PROCESSING 
function processInputArray(inputArray, connection) {
  return new Promise((resolve, reject) => {
    const successfulEntries = [];
    const duplicateEntries = [];

    // Helper function to check if a user with the given email already exists
    function checkUserExists(email) {
      return new Promise((resolve, reject) => {
        const query = "SELECT * FROM user WHERE Email = ?";
        connection.query(query, [email], (error, results) => {
          if (error) {
            reject(error);
          } else {
            resolve(results.length > 0);
          }
        });
      });
    }

    // Helper function to insert a new user into the database
    function createUser(firstName, lastName, email) {
      return new Promise((resolve, reject) => {
        const query = "INSERT INTO user (FirstName, LastName, Email) VALUES (?, ?, ?)";
        connection.query(query, [firstName, lastName, email], (error, results) => {
          if (error) {
            reject(error);
          } else {
            resolve();
          }
        });
      });
    }

    // Process each input object
    async function processInput(input) {
      const email = input["Email"];
      const firstName = input["First"];
      const lastName = input["Last"];

      try {
        const userExists = await checkUserExists(email);

        if (userExists) {
          duplicateEntries.push(input);
        } else {
          await createUser(firstName, lastName, email);
          successfulEntries.push({ FirstName: firstName, LastName: lastName });
        }
      } catch (error) {
        reject(error);
      }
    }

    // Process all input objects sequentially
    async function processInputArraySequentially() {
      try {
        for (const input of inputArray) {
          await processInput(input);
        }
        resolve({ successfulEntries, duplicateEntries });
      } catch (error) {
        reject(error);
      }
    }

    // Start processing the input array
    processInputArraySequentially();
  });
}

// Example usage
function YourComponent() {
  const [result, setResult] = useState(null);

  useEffect(() => {
    const inputArray = [
      {
        Last: "Doe",
        First: "John",
        Email: "john.doe@example.com",
        "Cost Center": "123",
        Home: "1234567890",
        Cell: "9876543210",
        "Personal Email": "john.doe.personal@example.com",
      },
      // Add more input objects as needed
    ];

    processInputArray(inputArray, yourDBConnection)
      .then((result) => {
        setResult(result);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);

  // Render the result
  return (
    <div>
      {result && (
        <div>
          <h2>Successful Entries:</h2>
          <ul>
            {result.successfulEntries.map((entry, index) => (
              <li key={index}>{`${entry.FirstName} ${entry.LastName}`}</li>
            ))}
          </ul>
          <h2>D*/

    const handleClickOpen = () => {

        setRefresh(true)
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setAllDoneAlert(false);
        
    };
    const handleAlertClose = () => {
        setAllDoneAlert(false);
        handleClose()
    };

    React.useEffect(() => {

        if (refresh) {
            
            setRefresh(false);
        }
    });
    return (
       <Box>
        <Box sx={{
            width: 400,
            height: 600,
            boxSizing: 'border-box',
            lineHeight: 1.4
        }} >
            <MuiThemeProvider theme={muiThemeDesign}>
                <Button variant="contained" onClick={handleClickOpen}>
                    Import Roster
                </Button>
            <Dialog open={open}
                    onClose={handleClose}
                     maxWidth="lg"
          //      fullScreen
            >
                <DialogContent className={classes.overflow }>
                    <Box>
                        
                            <h1>Roster Import</h1>

                            <Importer
                                dataHandler={async (rows) => {
                                    // required, receives a list of parsed objects based on defined fields and user column mapping;
                                    // may be called several times if file is large
                                    // (if this callback returns a promise, the widget will wait for it before parsing more data)
                               //     console.log("received batch of rows", rows);
                                    rowCount = rows.length;
                               //     console.log(`rowCount`, rowCount)                                  
                                 //   newRows.push(rows)
                                    processRows(rows)
                                    setAllDoneAlert(true)
                                            
                                    
                                    // mock timeout to simulate processing
                                    await new Promise((resolve) => setTimeout(resolve, 500));
                                }}
                                chunkSize={10000} // optional, internal parsing chunk size in bytes
                                defaultNoHeader={false} // optional, keeps "data has headers" checkbox off by default
                                restartable={false} // optional, lets user choose to upload another file when import is complete
                                onStart={({ file, fields }) => {
                                    // optional, invoked when user has mapped columns and started import
                                //    console.log("starting import of file", file, "with fields", fields);
                                }}
                                onComplete={({ file, fields }) => {
                                    // optional, invoked right after import is done (but user did not dismiss/reset the widget yet)
                                  //  console.log("finished import of file", file, "with fields", fields);
                                  //  console.log(`importRows`, importRows)
                                    pushRows(importRows)
                                }}
                                onClose={() => {
                                    // optional, invoked when import is done and user clicked "Finish"
                                    // (if this is not specified, the widget lets the user upload another file)
                                    console.log("importer dismissed");
                                }}
                            >
                                <ImporterField name="FirstName" label="FirstName" />
                                <ImporterField name="LastName" label="LastName" />
                                <ImporterField name="Email" label="Email" />
                                <ImporterField name="Lab" label="Lab" optional />
                                <ImporterField name="IsActive" label="IsActive" optional />
                                <ImporterField name="Position" label="Position" optional />
                                <ImporterField name="PONumber" label="PO Number" optional />
                                <ImporterField name="HRName" label="HRName" optional />
                                <ImporterField name="BCI#" label="BCI#" optional  />
                                <ImporterField name="HP#" label="HP#" optional />
                                <ImporterField name="PTO" label="PTO" optional />
                                <ImporterField name="Shift" label="Shift" optional />
                                <ImporterField name="Personal Email" label="Personal Email" optional />
                                <ImporterField name="HP Email" label="HP Email" optional />
                                <ImporterField name="Home Phone" label="Home Phone" optional />
                                <ImporterField name="Cell Phone" label="Cell Phone" optional />
                                <ImporterField name="BYS Date Start" label="BYS Date Start" optional />
                                <ImporterField name="DOB" label="Date of Birth" optional />
                          
                            </Importer>
                        
                      </Box>
                      
                </DialogContent>
                </Dialog> 
              
        </MuiThemeProvider>
            </Box>
            <Box
                className={classes.root }
                sx={{  
                    lineHeight: 0.9
                }}>
              <Dialog
                    open={AllDoneAlert}
                    onClose={handleAlertClose}
                    fullwidth="true"
                    maxWidth="lg"
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    className={classes.root}
                >
                    <DialogTitle className={classes.root} id="alert-dialog-title" sx={{ textAlign: "center", color: "#ffffff", backgroundColor: "#1976d2" } }>
                        Your Import is Complete
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <Grid container>
                                <Grid item xs={6} sx={{ border: '1px solid gray' }}>
                                   
                                    <Typography textAlign="center" variant="h6" style={{ color: "black" }}>
                                        New Users:
                                    </Typography>
                                
                                    <List>
                                        {successful.map(email => {
                                            return (
                                                <ListItem>
                                                    {email}
                                                </ListItem>
                                            ) } )    
                                        }
                                    </List>
                                </Grid>
                            <Grid item xs={6} sx={{ border: '1px solid gray' }}>
                                <Typography textAlign="center" variant="h6" style={{ color: "black" }}>
                                    Already Existed
                                </Typography>
                                    <List>
                                        {duplicates.map(email => {
                                            return (
                                                <ListItem>
                                                    {email}
                                                </ListItem>
                                            ) })
                                        }
                                    </List>
                                </Grid>
                            </Grid>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        
                        <Button onClick={() => {
                            handleAlertClose()
                            
                        }} autoFocus>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
                </Box ></Box >
    );
}
